import { useInstance, onBeforeMount, onBeforeUpdate } from 'intact-vue-next';
import { isComponentVNode, eachChildren } from '../utils';
import { getCollapseWidth } from './styles';
import { defaultHeight, defaultWidth } from './helpers';
import { Aside } from './aside';
import { Header } from './header';
import { EMPTY_OBJ } from 'intact-shared';
export function useParse() {
  var instance = useInstance();
  var hasAside;
  var hasFixedHeader;
  var headerHeight;
  var hasFixedAside;
  var asideWidth;
  onBeforeMount(parse);
  onBeforeUpdate(parse);
  function parse() {
    hasAside = false;
    hasFixedHeader = false;
    headerHeight = defaultHeight;
    hasFixedAside = false;
    asideWidth = defaultWidth;
    eachChildren(instance.get('children'), function (vNode) {
      if (isComponentVNode(vNode, Aside)) {
        hasAside = true;
        var props = vNode.props || EMPTY_OBJ;
        if (props.width) {
          asideWidth = props.width;
        }
        if (props.collapse) {
          asideWidth = getCollapseWidth(props.collapsedWidth);
        }
        if (props.fixed) {
          hasFixedAside = true;
        }
      } else if (isComponentVNode(vNode, Header)) {
        var _props = vNode.props || EMPTY_OBJ;
        if (_props.height) {
          headerHeight = _props.height;
        }
        if (_props.fixed) {
          hasFixedHeader = true;
        }
      }
    });
  }
  return function () {
    return {
      hasAside: hasAside,
      hasFixedHeader: hasFixedHeader,
      headerHeight: headerHeight,
      hasFixedAside: hasFixedAside,
      asideWidth: asideWidth
    };
  };
}